// extracted by mini-css-extract-plugin
module.exports = {"connected":"ThreepidAuthButton_connected__KN8iq"};